import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  Link,
  useMatch,
  useResolvedPath
} from 'react-router-dom';

import { Icon } from '@febos-io/design';

import useTranslation from '../hooks/useTranslation';

export function NavbarOption(
  {
    to,
    icon,
    text,
    theme = 'white',
    activeTheme = 'primary',
    className,
    style = {},
    classIcon,
    size,
    outline = false,
    rounded = false,
    linkProps = {},
    iconProps = {},
    i18nNamespace
  }
) {
  const { t } = useTranslation(i18nNamespace);
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: true });

  return (
    <li className={classNames('d-grid', className)}>
      <Link
        role="button"
        to={to}
        className={classNames(
          'btn text-start',
          `btn-${outline ? 'outline-' : ''}${match ? activeTheme : theme}`,
          size && `btn-${size}`,
          rounded && 'btn-rounded',
          className
        )}
        style={style}
        {...linkProps}
      >
        <Icon
          icon={icon}
          className={classNames('me-1', classIcon)}
          {...iconProps}
        />
        {t(text)}
      </Link>
    </li>
  );
}

NavbarOption.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  theme: PropTypes.string,
  activeTheme: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  classIcon: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg']),
  outline: PropTypes.bool,
  rounded: PropTypes.bool,
  linkProps: PropTypes.object,
  iconProps: PropTypes.object,
  i18nNamespace: PropTypes.string
};

export default NavbarOption;
